var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoadingTestRun = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4801 4.08056C10.8557 3.92546 10.2101 3.87044 9.56139 3.91705C9.24621 3.9397 8.93135 3.9866 8.62548 4.05656L8.31171 2.69095C8.68733 2.60508 9.07383 2.54745 9.46047 2.51968C10.2573 2.46243 11.051 2.53023 11.8196 2.72118L11.4801 4.08056Z",
    fill: "#006EB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.6839 6.07863C14.065 5.3446 13.2713 4.75872 12.3889 4.38445L12.9386 3.09521C14.0232 3.55521 14.9985 4.27503 15.7589 5.17691L14.6839 6.07863Z",
    fill: "#006EB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.0998 9.57207L16.0991 9.56167C16.0291 8.59247 15.7408 7.68242 15.242 6.85672L16.4451 6.13379C17.0591 7.15022 17.414 8.26968 17.5 9.46101L16.0998 9.57207Z",
    fill: "#006EB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.3807 13.9695L15.1895 13.2272C15.6988 12.414 16.0112 11.481 16.0929 10.5288L17.4924 10.6484C17.3918 11.8205 17.0074 12.969 16.3807 13.9695Z",
    fill: "#006EB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.8262 16.952L12.2987 15.6536C13.1857 15.2951 13.9881 14.7221 14.6192 13.9966L15.6801 14.9147C14.9045 15.8065 13.9176 16.5109 12.8262 16.952Z",
    fill: "#006EB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5409 17.4806C9.74772 17.5375 8.95779 17.4706 8.1929 17.2817L8.53032 15.9219C9.15181 16.0753 9.79436 16.1296 10.4401 16.0833C10.7584 16.0604 11.0763 16.0128 11.3849 15.9417L11.7008 17.3068C11.3218 17.394 10.9315 17.4526 10.5409 17.4806Z",
    fill: "#006EB7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.07342 16.9095C5.9881 16.4511 5.01177 15.7328 4.25003 14.8321L5.32355 13.9287C5.94366 14.6618 6.73809 15.2465 7.62108 15.6193L7.07342 16.9095Z",
    fill: "#006EB7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.56221 13.8759C2.94465 12.8566 2.58776 11.7339 2.50144 10.5387L2.5 10.5181L3.90092 10.4175L3.90274 10.4433C3.97258 11.4104 4.26253 12.3232 4.76425 13.1511L3.56221 13.8759Z",
    fill: "#006EB7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.90928 9.46206L2.51007 9.34039C2.6124 8.16846 2.99857 7.02055 3.62676 6.021L4.81682 6.76505C4.30626 7.57751 3.99243 8.51012 3.90928 9.46206Z",
    fill: "#006EB7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingTestRun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading-test-run.ec40bfa8.svg";
export { ForwardRef as ReactComponent };